import {
	Box,
	Chip,
	CircularProgress,
	Divider,
	Grid,
	IconButton,
	Table,
	TableBody,
	TableCell,
	TableRow,
	Tooltip,
	Typography,
} from "@material-ui/core";
import { common, grey } from "@material-ui/core/colors";
import { withStyles } from "@material-ui/core/styles";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import AssignmentIcon from "@material-ui/icons/Assignment";
import PersonIcon from "@material-ui/icons/Person";
import classNames from "classnames";
import clsx from "clsx";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router";
import { compose } from "redux";
import tesoura from "./../../images/tesoura.png";
import consts from "../../main/consts";
import { getLabelOrigem } from "../../main/origem";
import { STATUS, statusResolver, statusToPage } from "../../main/status";
import {
	getAllCounts,
	getOrderByNumero,
	verifyDevolution,
} from "../../state/order/actions";
import { useRemoteConfig } from "../../state/remoteConfig/RemoteConfigContext";
import {
	isDevolutionAllowedForSalesChannel,
	salesChannelIs99food,
	salesChannelIsMarketplaceOut,
} from "../../utils/check-sales-channel";
import { getEansFormatados } from "../../utils/eans";
import Details from "./Details";
import AlertaDevolucaoNotaFiscal from "./Details/AlertaDevolucaoNotaFiscal";
import AlertaDevolucaoPendente from "./Details/AlertaDevolucaoPendente";
import { AlertaPedidoMarketplaceOut } from "./Details/AlertaPedidoMarketplaceOut";
import AlertaPreVenda from "./Details/AlertaPreVenda";
import AlertaRetiradaPendente from "./Details/AlertaRetiradaPendente";
import MandatorySteps from "./Details/MandatorySteps/MandatorySteps";
import Items from "./Items";
import OrderActions from "./OrderActions";
import ReadyToGoDetailAlert from "./ready-to-go/components/ReadyToGoDetailAlert/ReadyToGoDetailAlert";
import Timeline from "./Timeline";

const styles = (theme) => ({
	header: {
		minHeight: 64,
	},
	body: {
		height: "calc(100% - 202px)",
		[theme.breakpoints.down("xs")]: {
			height: "auto",
		},
	},
	contentStatusHistory: {
		height: 90,
		pageBreakAfter: "always",
		[theme.breakpoints.down("xs")]: {
			height: "auto",
		},
	},
	bodyItems: {
		overflowY: "auto",
		height: "100%",
		paddingRight: "16px",
		[theme.breakpoints.down("xs")]: {
			height: "auto",
		},
	},
	bodyDetails: {
		overflowY: "auto",
		paddingLeft: theme.spacing(1),
		borderLeft: "1px solid rgba(0,0,0,.12)",
		height: "100%",
		[theme.breakpoints.down("xs")]: {
			borderTop: "1px solid rgba(0,0,0,.12)",
			paddingLeft: 0,
			borderLeft: "none",
			height: "auto",
		},
	},
	pageBreak: {
		pageBreakBefore: "always",
	},
	bodyLoading: {
		height: "100%",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	footer: {
		height: 54,
		paddingTop: theme.spacing(2),
		[theme.breakpoints.down("xs")]: {
			height: "auto",
		},
	},
	buttonBack: {
		marginTop: 4,
		marginRight: theme.spacing(1),
		backgroundColor: grey[100],
		padding: theme.spacing(1),
	},
	iconBack: {
		fontSize: theme.spacing(4),
	},
	divider: {
		margin: 0,
	},
	icon: {
		fontSize: 17,
		marginBottom: -2,
		marginRight: theme.spacing(1),
	},
	contentPrint: {
		height: "100%",
	},
	cabeçalho: {
		"@media print": {
			visibility: "hidden",
		},
	},
	cabecalhoImpressao: {
		visibility: "hidden",
		height: 0,
		"@media print": {
			visibility: "visible",
			height: "auto",
		},
	},
	logotype: {
		"@media print": {
			width: "auto",
			marginTop: `-${theme.spacing(2)}px`,
			marginBottom: theme.spacing(2),
			height: 32,
			visibility: "visible",
		},
	},
	bodyImpressao: {
		visibility: "hidden",
		height: 0,
		"@media print": {
			paddingTop: theme.spacing(6),
			visibility: "visible",
		},
	},
	rowPrint: {
		width: "20vh",
		paddingLeft: 0,
	},
	title: {
		marginTop: theme.spacing(2),
		fontSize: 20,
	},
	atencao: {
		color: common[500],
	},
	text: {
		color: theme.palette.primary.dark,
	},
	capitalize: {
		textTransform: "capitalize",
	},
	table: {
		border: 0,
		display: "none",
		"@media print": {
			display: "block",
			marginTop: -80,
		},
	},
	tableCell: {
		border: 0,
	},
	tableCellText: {
		border: 0,
		width: "100%",
	},
	tableLine: {
		marginTop: 25,
		marginBottom: 25,
		borderBottom: "1px dashed #000",
	},
	tesoura: {
		width: "100%",
		height: 49,
		marginBottom: 15,
	},
	tableHeader: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		border: 0,
		marginBottom: 10,
	},
	listItem: {
		borderLeft: 4,
		backgroundColor: "#ECEBEE",
		borderLeftStyle: "solid",
		margin: "10px 0px 10px",
		padding: "15px",
		borderRadius: 4,
		"&.new-orders": {
			borderColor: theme.palette.pages["new-orders"],
		},
		"&.estimated": {
			borderColor: theme.palette.pages["estimated"],
		},
		"&.picking": {
			borderColor: theme.palette.pages["picking"] || "#00CBFF",
		},
		"&.ready-to-go": {
			borderColor: theme.palette.pages["ready-to-go"] || "#FFAA00",
		},
		"&.shipping": {
			borderColor: theme.palette.pages["shipping"] || "#CE00FF",
		},
		"&.returning-to-storage": {
			borderColor: theme.palette.pages["returning-to-storage"] || "#B72F2C",
		},
		"&.history": {
			borderColor: theme.palette.pages["history"] || "#757575",
		},
	},
	chip: {
		marginLeft: "1rem",
		borderRadius: "8px",
		padding: "4px 16px !important",
		fontWeight: "700",
		fontSize: "16px",
	},
	secondaryChip: {
		marginLeft: "1rem",
		borderRadius: "8px",
		padding: "4px 16px !important",
		fontWeight: "700",
		fontSize: "16px",
		backgroundColor: "#760018",
		color: "#fff",
	},
	stateDeliveryChip: {
    backgroundColor: "#4056C7",
    color: "#fff",
},
	alertNf: {
		marginTop: "1.5rem",
		marginBottom: "2rem",
		"&.without-margin-bottom": {
			marginBottom: "0",
		},
	},
	dividerForMandatorySteps: {
		marginTop: "1.5rem",
		marginBottom: "0",
	},
});

function OrderDetails(props) {
	const { classes } = props;
	const printRef = React.useRef();
	const dispatch = useDispatch();
	const { getToggleFeature } = useRemoteConfig();
	const [refreshes, setRefreshes] = useState(1);
	const { page, orderId } = props.match.params;
	const { order, loaded } = useSelector((state) => state.orders);
	const dataCriacaoPedido = moment(order.dataCriacao).format("DD/MM/YYYY");
	const dataEntregaEstimada = moment
		.utc(order.dhEntregaEstimada)
		.format("DD/MM/YYYY");
	const podeDevolver = useSelector((state) => state.orders.devolution);

	const [retirarPedidoAbbiamo, setRetirarPedidoAbbiamo] = useState({
		shouldShowAlerta: false,
		handler: undefined,
	});

	const eventoRetornoAbbiamo = order?.events?.find(
		(event) =>
			event.eventName === "SAIU_PARA_ENTREGA" &&
			event.tipo === "AGUARDANDO_DEVOLUCAO_ABBIAMO" &&
			event.status !== "DONE",
	);
	const showAlertaDevolucaoPendente =
		eventoRetornoAbbiamo &&
		moment(eventoRetornoAbbiamo.dataCriacao)
			.add(consts.SECONDS_TO_ALERT_DEVOLUTION_ABBIAMO, "seconds")
			.isBefore(moment());
	const newPrintReceipt = getToggleFeature
		? getToggleFeature("order", "details", "newReceipt")
		: false;
	const showMandatorySteps =
		order?.tipoEntrega === "SAME_STATE" &&
		["PRONTO_PARA_SAIR", "SAIU_PARA_ENTREGA", "FINALIZADO"].includes(
			order?.status,
		);

	useEffect(() => {
		if (orderId) {
			dispatch(getOrderByNumero(orderId, refreshes > 1));
			dispatch(getAllCounts());
			dispatch(verifyDevolution());
		}
	}, [dispatch, orderId, refreshes]);

	useEffect(() => {
		const interval = setInterval(() => {
			setRefreshes((prevRefreshes) => prevRefreshes + 1);
		}, consts.POOLING_DETAILS_DELAY || 5000);

		return () => {
			clearInterval(interval);
		};
	});

	useEffect(() => {
		const { page } = props.match.params;
		const { orderId } = props.match.params;

		if (order.status && order.numero === orderId) {
			const setRouteByStatus = () => {
				const _page = order.status ? statusToPage[order.status] : page;
				if (page !== statusToPage[order.status]) {
					if (
						order.status === STATUS.CANCELADO ||
						order.status === STATUS.FINALIZADO
					) {
						props.history.push(`${consts.CONTEXT}/history/${order.numero}`, {
							data: { page: "history" },
						});
					} else {
						props.history.push(`${consts.CONTEXT}/${_page}/${order.numero}`, {
							data: { page: _page },
						});
					}
				}
			};
			setRouteByStatus();
		}
	}, [dispatch, props, order]);

	return (
		<div ref={printRef} className={classes.contentPrint}>
			{/* Início Header */}
			<Grid container spacing={0} className={classes.header}>
				<Grid item xs={12}>
					<Box display="flex" p={0}>
						<Box>
							<Tooltip title="Voltar">
								<IconButton
									className={classes.buttonBack}
									onClick={() => {
										props.history.replace(`${consts.CONTEXT}/${page}`);
									}}
								>
									<ArrowBackIcon className={classes.iconBack} />
								</IconButton>
							</Tooltip>
						</Box>
						<Box flexGrow={1} className={classes.cabeçalho}>
							<Box display={"flex"} alignItems={"center"}>
								<Typography variant="h6">
									<AssignmentIcon className={classes.icon} />
									{order.codigoExterno && order.codigoExterno.split("#")[0]}
								</Typography>
								{order.erpOrigem && (
									<Tooltip title="Canal de venda" placement="top">
										<Chip
											label={order.canalDeVendas}
											size="small"
											color="primary"
											className={classes.chip}
										/>
									</Tooltip>
								)}
								{order.origem && (
									<Tooltip title="Origem" placement="top">
										<Chip
											label={getLabelOrigem(order.origem)}
											size="small"
											className={`${classes.chip} ${classes.secondaryChip}`}
										/>
									</Tooltip>
								)}
								{order.tipoEntrega === "SAME_STATE" && (
									<Tooltip title="Tipo de Entrega" placement="top">
										<Chip
											label="Estadual"
											size="small"
											className={`${classes.chip} ${classes.stateDeliveryChip}`}
										/>
									</Tooltip>
								)}
							</Box>
							<Typography variant="subtitle1">
								<Grid container justify="space-between">
									<span className={classes.capitalize}>
										<PersonIcon className={classes.icon} />
										{order.cliente && order.cliente.nome.toLowerCase()}
									</span>
								</Grid>
							</Typography>
						</Box>
					</Box>
				</Grid>
			</Grid>
			{/* Fim Header */}

			{/* Impressão de pedido */}
			<Box flexGrow={1} className={classes.cabecalhoImpressao}>
				<Table
					className={classes.table}
					size="small"
					aria-label="a dense table"
				>
					<TableBody>
						<TableRow>
							<TableCell className={classes.tableHeader}>
								<Typography variant="h5" style={{ fontSize: 18 }}>
									<strong className={classes.atencao}>
										{order.codigoExterno}
									</strong>
								</Typography>
								<Typography variant="h1">
									<strong className={classes.atencao} style={{ fontSize: 36 }}>
										{order.recebedor && order.recebedor.nome.charAt(0)}
									</strong>
								</Typography>
							</TableCell>
						</TableRow>
						{order.canalDeVendas && (
							<TableRow>
								<TableCell className={classes.tableCell}>
									<Typography variant="h5" style={{ fontSize: 15 }}>
										<strong className={classes.atencao}>
											{order.canalDeVendas}
										</strong>
									</Typography>
								</TableCell>
							</TableRow>
						)}
						<TableRow>
							<TableCell className={classes.tableCell}>
								<Typography variant="h5" style={{ fontSize: 15 }}>
									<strong className={classes.atencao}>
										{getLabelOrigem(order.origem)} {order.tipoEntrega === "SAME_STATE" && " - Estadual"}
									</strong>
								</Typography>
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell className={classes.tableCell}>
								<Typography variant="h5" style={{ fontSize: 16 }}>
									<strong className={classes.atencao}>
										Criação do pedido: {dataCriacaoPedido}
									</strong>
								</Typography>
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell className={classes.tableCell}>
								<Typography variant="h5" style={{ fontSize: 16 }}>
									<strong className={classes.atencao}>
										Entrega Estimada: {dataEntregaEstimada}
									</strong>
								</Typography>
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell className={classes.tableCell}>
								<Typography variant="h5" style={{ fontSize: 16 }}>
									<strong className={classes.atencao}>
										Nome do cliente: {order.cliente && order.cliente.nome}
									</strong>
								</Typography>
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell className={classes.tableCell}>
								<Typography variant="h5" style={{ fontSize: 16 }}>
									<strong className={classes.atencao}>
										Nome do recebedor: {order.recebedor && order.recebedor.nome}
									</strong>
								</Typography>
							</TableCell>
						</TableRow>

						<TableRow>
							<TableCell className={classes.tableCell}>
								<Typography variant="h5" style={{ fontSize: 16 }}>
									<strong className={classes.atencao}>
										{order.cliente && (
											<span>
												Endereço:{" "}
												{order.cliente.endereco &&
													`${order.cliente.endereco}, `}
												{order.cliente.numero && `${order.cliente.numero}, `}
												{order.cliente.complemento &&
													`${order.cliente.complemento}, `}
												{order.cliente.bairro && `${order.cliente.bairro}, `}
												{order.cliente.cidade && `${order.cliente.cidade}`}
												{order.cliente.uf && ` - ${order.cliente.uf}`}
												{order.cliente.cep && ` | ${order.cliente.cep}`}
											</span>
										)}
									</strong>
								</Typography>
							</TableCell>
						</TableRow>

						<TableRow>
							<TableCell className={classes.tableCell}>
								<Typography
									variant="subtitle1"
									style={{ fontSize: 11, marginTop: 20, textAlign: "center" }}
								>
									Atenção! A Nota Fiscal foi enviada para o e-mail <br />{" "}
									utilizado no ato da compra.
								</Typography>
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell className={classes.tableCellText}>
								<Typography
									variant="subtitle1"
									style={{
										fontSize: 10,
										marginTop: 30,
										textAlign: "center",
										marginBottom: -35,
									}}
								>
									Recorte aqui! A parte inferior não deve ser
									<br />
									disponibilizada para o cliente/entregador.
								</Typography>
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell className={classes.tableCell}>
								<img src={tesoura} alt="icon" className={classes.tesoura} />
							</TableCell>
						</TableRow>

						<TableRow>
							<TableCell className={classes.tableCell}>
								<Typography
									variant="h5"
									style={{ fontSize: 16, marginBottom: 20 }}
								>
									<strong className={classes.atencao}>
										{order.codigoExterno}
									</strong>
								</Typography>
							</TableCell>
						</TableRow>

						{order.itens &&
							order.itens
								.filter(
									(p) => p.quantidadeTotal == null || p.quantidadeTotal > 0,
								)
								.map((item, index) => (
									<TableRow key={item.codigoEAN + "-" + (index + 1)}>
										<TableCell className={classes.tableCell}>
											<Typography
												variant="h5"
												className={classes.text}
												style={{ fontSize: 12 }}
											>
												{item.quantidadeTotal || item.quantidade}x{" "}
												{item.descricao} (EAN: {getEansFormatados(item)})
											</Typography>
										</TableCell>
									</TableRow>
								))}
					</TableBody>
				</Table>
			</Box>
			{/* Fim da Impressão de pedido */}

			{/* Timeline */}
			<Grid
				container
				spacing={0}
				className={clsx(classes.contentStatusHistory, "printHide")}
			>
				<Grid item xs={12}>
					<Divider variant="middle" className={classes.divider} />
				</Grid>
				<Grid item xs={12}>
					<Timeline
						orderStatus={order.status}
						tipoEntrega={order.tipoEntrega}
						orderTimelines={order.timelines}
						origem={order.origem}
					/>
				</Grid>
			</Grid>
			{/* Fim da timeline */}

			{/* Listagem de produtos e detalhes */}
			<Grid container spacing={0} className={clsx(classes.body, "printHide")}>
				<Grid item xs={12}>
					<Divider variant="middle" className={classes.divider} />
				</Grid>
				{loaded && order ? (
					<>
						<Grid
							item
							xs={12}
							sm={7}
							md={8}
							className={clsx(classes.bodyItems, "printHide")}
						>
							{page === "ready-to-go" && (
								<ReadyToGoDetailAlert order={order} />
							)}

							{order.erpOrigem &&
								salesChannelIsMarketplaceOut(order.erpOrigem) && (
									<Box className={classes.alertNf}>
										{![
											STATUS.FINALIZADO,
											STATUS.DEVOLVIDO,
											STATUS.CANCELADO,
											STATUS.SAIU_PARA_ENTREGA,
										].includes(order.status) ? (
											<AlertaPedidoMarketplaceOut
												newPrintReceipt={newPrintReceipt}
												order={order}
											/>
										) : (order.status === STATUS.FINALIZADO &&
												!isDevolutionAllowedForSalesChannel(order.erpOrigem)) ||
											(order.status === STATUS.SAIU_PARA_ENTREGA &&
												salesChannelIs99food(order.erpOrigem)) ? (
											<AlertaDevolucaoNotaFiscal
												canalDeVendas={order.canalDeVendas}
											/>
										) : null}
									</Box>
								)}

							{retirarPedidoAbbiamo.shouldShowAlerta && (
								<Box
									className={`${classes.alertNf} ${showMandatorySteps ? "without-margin-bottom" : ""}`}
								>
									<AlertaRetiradaPendente
										handleRetirarPedidoAbbiamo={() => {
											retirarPedidoAbbiamo.handler &&
												retirarPedidoAbbiamo.handler();
											setRetirarPedidoAbbiamo((prev) => ({
												...prev,
												shouldShowAlerta: false,
											}));
										}}
										showMandatorySteps={showMandatorySteps}
									/>

									{showMandatorySteps && (
										<Divider className={classes.dividerForMandatorySteps} />
									)}
								</Box>
							)}

							{showAlertaDevolucaoPendente && <AlertaDevolucaoPendente />}

							{showMandatorySteps && <MandatorySteps />}

							{order.preVenda && <AlertaPreVenda dataLancamento={order.dhEntregaEstimada}/>}

							{order.origem !== "PEGUE_NA_LOJA" && (
								<Items
									items={
										order.itens &&
										order.itens.filter((item) =>
											item.quantidadeTotal != null
												? item.quantidadeTotal > 0
												: item.quantidade > 0,
										)
									}
									currency={order.currency}
									subtotal={order.valorSubtotal || 0}
									entrega={order.valorEntrega || 0}
									desconto={order.valorDesconto || 0}
									total={order.valorTotal}
									status={order.status}
								/>
							)}

							{order.origem === "PEGUE_NA_LOJA" && (
								<Box style={{ paddingRight: 10 }}>
									<Typography
										style={{
											fontSize: 12,
											fontWeight: "bold",
											marginLeft: 20,
											marginTop: 30,
											marginBottom: 5,
										}}
									>
										N° Entrega
									</Typography>
									<Box
										className={classNames(
											classes.listItem,
											statusToPage[order.status],
										)}
									>
										<Typography>
											{order.entregas &&
												order.entregas[0] &&
												order.entregas[0].codigo.split("-")[1]}
										</Typography>
									</Box>
								</Box>
							)}
						</Grid>

						<Grid
							item
							xs={12}
							sm={5}
							md={4}
							className={clsx(classes.bodyDetails, "printHide")}
						>
							<Details
								dataInclusao={order.dataInclusao}
								associado={order.associado || {}}
								recebedor={order.recebedor || {}}
								cliente={order.cliente || {}}
								address={order.address ? order.address : {}}
								status={statusResolver[order.status] || order.status}
								motivo={order.motivo}
								pago={order.pago}
								erpOrigem={order.erpOrigem}
								canalDeVendas={order.canalDeVendas}
								pagamentoStatus={order.pagamentoStatus}
								origem={order.origem}
								tipoEntrega={order.tipoEntrega}
								page={page}
								notaFiscal={order.notaFiscal}
								notaFiscalDevolucao={order.notaFiscalDevolucao}
								numero={order.numero}
								codigoExterno={order.codigoExterno}
								distancia={order.distancia}
								eventos={order.events}
								timelines={order.timelines}
								deliveryToken={order.deliveryToken}
								deEntregaEstimada={order.deEntregaEstimada}
								dhEntregaEstimada={order.dhEntregaEstimada}
								tempoConfirmacao={order.tempoConfirmacao}
								transportadora={order.transportadora}
							/>
						</Grid>
					</>
				) : (
					<Grid item xs={12} className={classes.bodyLoading}>
						<CircularProgress />
					</Grid>
				)}
				<Grid item xs={12}>
					<Divider variant="middle" className={classes.divider} />
				</Grid>
			</Grid>
			{/* Fim da Listagem de produtos e detalhes */}

			{/* Footer */}
			<Grid container spacing={0} className={classes.footer}>
				<Grid item xs={12}>
					<OrderActions
						aceitarDevolucao={podeDevolver}
						order={order}
						printRef={printRef}
						setRefreshes={setRefreshes}
						ignoreReason={order.status === STATUS.PRONTO_PARA_SAIR}
						setRetirarPedidoAbbiamo={setRetirarPedidoAbbiamo}
					/>
				</Grid>
			</Grid>
			{/* Fim do footer */}
		</div>
	);
}

export default compose(withRouter, withStyles(styles))(OrderDetails);
